webpackJsonp([79611799117203,60335399758886],{

/***/ 112:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(232);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(112);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(473);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import '../assets/scripts/tongwen_core';
	// import '../assets/scripts/tongwen_table_s2t.js';
	// import '../assets/scripts/tongwen_table_t2s.js';
	// import '../assets/scripts/tongwen_table_pt2s.js';
	// import '../assets/scripts/tongwen_table_ps2t.js';
	
	var toTradChinese = function toTradChinese(obj) {
	  return TongWen.convert(obj, 'traditional');
	};
	var toSimpChinese = function toSimpChinese(obj) {
	  return TongWen.convert(obj, 'simplified');
	};
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  // constructor(props) {
	  //   super(props);
	  //   this.state = { isTradChinese: true };
	  //   this.translate = this.translate.bind(this);
	  // }
	
	  // translate() {
	  //   const { isTradChinese } = this.state;
	  //   const layout = typeof document !== 'undefined' && document.querySelector('.layout');
	  //   const layoutContent = layout && (layout.querySelector('.post-single__inner') || layout.querySelector('.content__inner') || layout.querySelector('.page'));
	  //   layoutContent.innerHTML = isTradChinese ? toSimpChinese(layoutContent.innerHTML) : toTradChinese(layoutContent.innerHTML);
	  //   this.setState(prevState => ({ isTradChinese: !prevState.isTradChinese }));
	  // }
	
	  // componentDidUpdate(prevProps, prevState) {
	  //   if (prevState.isTradChinese === this.state.isTradChinese) {
	  //     this.setState({ isTradChinese: !this.state.isTradChinese });
	  //   }
	  // }
	
	  Layout.prototype.render = function render() {
	    var children = this.props.children;
	    // const { isTradChinese } = this.state;
	
	    return (
	      // <div className={`layout ${!isTradChinese && 'simp'}`}>
	      _react2.default.createElement(
	        'div',
	        { className: 'layout' },
	        _react2.default.createElement(_reactHelmet2.default, { defaultTitle: 'Jason Lam' }),
	        children()
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-ebfa35ad5b5890f76a89.js